"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { CartProvider } from "./cartContext";
import { CategoryProvider } from "./selectedCategoryContext";
import { MessageProvider } from "./messageContext";
import { queryClient } from "@/api/http-client/base-client";
import { InfoProvider } from "./infoContext";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultBg: "#e1e1e1",
              textTextHoverColor: "#AF2F18",
              textTextColor: "#af2f18",
              colorPrimaryBg: "#af2f18",
              colorPrimaryText: "#F8F3EC",
              primaryColor: "#F8F3EC",
            },
          },
        }}
      >
        <InfoProvider>
          <CartProvider>
            <CategoryProvider>
              <MessageProvider>{children}</MessageProvider>
            </CategoryProvider>
          </CartProvider>
        </InfoProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
}
